import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onGhostTextShownEvent = ({
	attributes,
	nonPrivacySafeAttributes,
}: {
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'ui',
	action: 'shown',
	actionSubject: `ghostText`,
	actionSubjectId: 'customGhostText',
	attributes,
	nonPrivacySafeAttributes,
});
